import { SUPPORTED_UNITS } from '@/helpers/unit-formatter/unit-formatter.constants';
import { UnitFormatterType } from '@/helpers/unit-formatter/unit-formatter.types';

import { formatBoolean } from './format-boolean';
import { formatCompactNumber } from './format-compact-number';
import { formatDefault } from './format-default';
import { formatDegree } from './format-degree';
import { formatDirection } from './format-direction';
import { formatDuration } from './format-duration';
import { formatMph } from './format-mph';
import { formatNone } from './format-none';
import { formatNumber } from './format-number';
import { formatPercent } from './format-percent';
import { formatPid } from './format-pid';
import { formatPPM } from './format-ppm';
import { formatPsi } from './format-psi';
import { formatPsigInhg } from './format-psig-inhg';
import { formatRatePerKwh } from './format-rate-per-kwh';
import { formatTime } from './format-time';

/**
 * The formatters object is a registry of functions that are used to format different units of measurement.
 * The key is the display unit that the formatter is used for.
 */
const formatters: Record<string, UnitFormatterType> = {
  [SUPPORTED_UNITS.$_PER_KWH]: formatRatePerKwh,
  [SUPPORTED_UNITS.ON_OFF]: formatBoolean,
  [SUPPORTED_UNITS.OPEN_CLOSED]: formatBoolean,
  [SUPPORTED_UNITS.A]: formatDefault,
  [SUPPORTED_UNITS.AMPS]: formatDefault,
  [SUPPORTED_UNITS.BOOLEAN]: formatBoolean,
  [SUPPORTED_UNITS.COMPACT_NUMBER]: formatCompactNumber,
  [SUPPORTED_UNITS.DEGREES_C]: formatDefault,
  [SUPPORTED_UNITS.C]: formatDefault, // alias for °c
  [SUPPORTED_UNITS.CELSIUS]: formatDefault, // alias for °c
  [SUPPORTED_UNITS.DURATION]: formatDuration,
  [SUPPORTED_UNITS.TIMER]: formatDuration,
  [SUPPORTED_UNITS.DEGREES_F]: formatDefault,
  [SUPPORTED_UNITS.F]: formatDefault, // alias for °f
  [SUPPORTED_UNITS.FAHRENHEIT]: formatDefault, // alias for °f
  [SUPPORTED_UNITS.DIRECTION]: formatDirection,
  [SUPPORTED_UNITS.DEG]: formatDegree,
  [SUPPORTED_UNITS.DEGREE]: formatDegree, // alias for deg
  [SUPPORTED_UNITS.DEGREES]: formatDegree, // alias for deg
  [SUPPORTED_UNITS.HRS]: formatTime,
  [SUPPORTED_UNITS.HZ]: formatDefault,
  [SUPPORTED_UNITS.KVA]: formatDefault,
  [SUPPORTED_UNITS.KVAH]: formatDefault,
  [SUPPORTED_UNITS.KVAR]: formatDefault,
  [SUPPORTED_UNITS.KVARH]: formatDefault,
  [SUPPORTED_UNITS.KW]: formatDefault,
  [SUPPORTED_UNITS.KWH]: formatDefault,
  [SUPPORTED_UNITS.MIN]: formatTime,
  [SUPPORTED_UNITS.MPH]: formatMph,
  [SUPPORTED_UNITS.NONE]: formatNone,
  [SUPPORTED_UNITS.NUMBER]: formatNumber,
  [SUPPORTED_UNITS.PERCENT_SYMBOL]: formatPercent,
  [SUPPORTED_UNITS.PERCENT]: formatPercent, // alias for %
  [SUPPORTED_UNITS.PERCENTAGE]: formatPercent, // alias for %
  [SUPPORTED_UNITS.PID]: formatPid,
  [SUPPORTED_UNITS.PPM]: formatPPM,
  [SUPPORTED_UNITS.PSI]: formatPsi,
  [SUPPORTED_UNITS.PSIA]: formatPsi,
  [SUPPORTED_UNITS.PSIG]: formatPsi,
  [SUPPORTED_UNITS.PSIG_INHG]: formatPsigInhg,
  [SUPPORTED_UNITS.RPM]: formatDefault,
  [SUPPORTED_UNITS.SEC]: formatTime,
  [SUPPORTED_UNITS.STRING]: formatNone,
  [SUPPORTED_UNITS.TR]: formatDefault,
  [SUPPORTED_UNITS.KW_PER_TR]: formatDefault,
  [SUPPORTED_UNITS.V]: formatDefault,
  [SUPPORTED_UNITS.VDC]: formatDefault,
};

export default formatters;
